import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { userSchemaObject } from '../userSchema';
import { Fields, validateProperty, validate, Card } from "../../Common";
import MessageModal from '../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'USER';

export function UserAddEdit(props) {

    const { data, edit } = props.location
    const [pageProperties, setPageProperties] = useState({
        title: 'Add User',
        submitButtonName: 'Save',
     })
    const [roles, setRoles] = useState()
    const [groups, setGroups] = useState()
    const [entityType, setEntityType] = useState()
    const [factories, setFactories] = useState()
    const [factoriesData, setFactoriesData] = useState()
    const [errors, setErrors] = useState({})
    const [entityTypeId, setEntityTypeId] = useState()

    const [user, setUser] = useState({
        id: '0',
        userName: '',
        passwordHash: '',
        email: '',
        firstName: '',
        lastName: '',
        roleId: '',
        isActive: true,
        isLocked: false,
        groupID: 0,
        operationEntityID: 0,
        entityTypeID: 0
    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(userSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        );
    }, [user.groupID]);

    useEffect(() => {
        trackPromise(
            setRolesDropDown()
        );

    }, [user.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITUSER');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined
        });
        
        if (data && edit) {
            setPageProperties({
                ...pageProperties,
                title:"Edit User",
                submitButtonName:"Update",
            });

            setUser(data);
            setDropDownForEdit();
        } else {
            setPageProperties({
                ...pageProperties,
                title:"Add User",
            });

            var token = tokenService.getUserDetailsFromToken();
            setUser({
                ...user,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        trackPromise(
            setGroupsDropDown()
        );
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.getAllOperationEntitiesForDropDown(user.groupID);
        setFactories(opEntities);
    }

    function handleChange(e) {
        const target = e.target
        
        const value = (target.name === 'isActive' || target.name === 'isLocked') ? target.checked : target.value
        
        const error = { ...errors }
        const errorMessage = validateProperty(target, userSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setUser({
            ...user,
            [e.target.name]: value
        })
        setErrors(error)
    }


    function handleGroupChange(e) {

        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, userSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setUser({
            ...user,
            [e.target.name]: value
        })
            let entityTypeId = user.entityTypeID
        trackPromise(
            FactoryByGroupEntity(value, entityTypeId)
            )

        setErrors(error)

    }

    async function FactoryByGroupEntity(groupId, entityTypeId) {
        if (groupId > 0 && entityTypeId > 0) {
            let filteredData = await services.getOperationalEntityByGroupEntityID(groupId, entityTypeId);
            setFactories(filteredData)
        }
        else {
            setFactories([])
        }
    }

    function handleSave(e) {
        e.preventDefault()
        const target = e.target

        const errorMessages = validate(schema, user)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        let passwordFlag = false

        if (errorMessages != null) {
            var array = Object.keys(errorMessages);

            if (array.length === 1 && array.indexOf("passwordHash") === 0) {
                passwordFlag = true;
            }
        }

        if (errorMessages && !passwordFlag && !edit) {
            return
        }

        saveData();
        setErrors(errors)

    }

    async function saveData() {
       
        if (!edit) {
            const response = await services.saveDataV2(user)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
        if (edit) {
            const response = await services.editDataV2(user)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/users' })
            }, 1500);
        }
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        if (edit == true) {
            setUser(data);
            setDropDownForEdit();
        } else {
            setUser({
                ...user,
                id: '0',
                userName: '',
                passwordHash: '',
                email: '',
                firstName: '',
                lastName: '',
                roleId: '',
                active: true,
                isLocked: false,
                groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
                operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
                entityTypeID: 0
            });
        }
    }

    async function setDropDownForEdit() {
        const result = await services.getFactories()
        setFactoriesData(result);

        if (edit == true) {
            let entityTypeId = 0

            for (let item of Object.entries(result)) {
                if (data.operationEntityID == item[1]["operationEntityID"] && data.groupID == item[1]["groupID"]) {
                    entityTypeId = item[1]["enityTypeID"]
                }
            }
            FactoryByGroupEntity(data.groupID, entityTypeId)

            setEntityTypeId(entityTypeId)
         
        }
    }

    async function setRolesDropDown() {
        var FilterRoleModel = {
            groupID: (user.groupID),
            operationEntityID: (user.operationEntityID),
            roleLevel : tokenService.getRoleLevelFromToken()
        }
        const result = await services.getAllRoles(FilterRoleModel); 
        
        setRoles(result)
    }

    async function setGroupsDropDown() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function setEntityTypeDropDown() {
        const result = await services.getEntityTypes()
        setEntityType(result)
    }


    function renderDropDown(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items;
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function setMessage(hidden, type, status) {
        setMessageModel({ ...messageModel, hidden: hidden, type: type, disciption: status })
    }

    function onCancelClick() {
        clearState();
        setErrors({});
    }
    function keyDown(e) {
        var e = window.event || e;
        var key = e.keyCode;
        if (key == 32) { 
             e.preventDefault();
        }
     }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">

                <div className="card">
                    <PageHeader
                        title={pageProperties.title}
                        isButtonEnable={true}
                        buttonText="Back to Listing"
                        path="/users"
                        />


                    <form onSubmit={(e) => handleSave(e)}>
                    <div className="card-body">


                        <div className="form-group row">
                            <div className="col-md">
                                 <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={user.groupID}
                                        onChange={(e) => handleGroupChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                        {renderDropDown(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                               
                            </div>
                            <div className="col-md">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={user.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                        {renderDropDown(factories)}
                                    </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                               
                            </div>
                        </div>


                        <div className="form-group row">
                           <div className="col-md">
                                        <InputLabel shrink id="userName">Username *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            name="userName"
                                            id="userName"
                                            onChange={(e) => handleChange(e)}
                                            value={user.userName}
                                            maxLength={12}
                                            onKeyDown={(e) => keyDown(e)}
                                            disabled={edit}
                                                                                      
                                    />
                                        {errors["userName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["userName"]}</FormHelperText>}      
                            </div>

                            <div className="col-md">
                                        <InputLabel shrink id="firstName">First Name *</InputLabel>
                                        <TextField
                                            fullWidth 
                                            type="text" 
                                            name="firstName"
                                            id="firstName"
                                            onChange={(e) => handleChange(e)}
                                            value={user.firstName}

                                    />
                                        {errors["firstName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["firstName"]}</FormHelperText>}
                               
                            </div>

                            <div className="col-md">
                                 <div className="form-group">
                                            <InputLabel shrink id="lastName">Last Name *</InputLabel>
                                     <TextField
                                            fullWidth 
                                            type="text"
                                            name="lastName"
                                            id="lastName"
                                            onChange={(e) => handleChange(e)}
                                            value={user.lastName}

                                    />
                                            {errors["lastName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["lastName"]}</FormHelperText>}
                                </div>
                            </div>



                        </div>

                        <div className="form-group row">

                                    <div className="col-md"> 
                                        <InputLabel shrink id="email">Email </InputLabel>
                                        <TextField
                                            fullWidth 
                                            type="text" 
                                            name="email"
                                            id="email"
                                            onChange={(e) => handleChange(e)}
                                            value={user.email}
                                        />
                                        {errors["email"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["email"]}</FormHelperText>}
                               
                                     </div>

                                    <div className="col-md" hidden={edit}>
                                        <InputLabel shrink id="passwordHash">Password *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="password"
                                            name="passwordHash"
                                            id="passwordHash"
                                            onChange={(e) => handleChange(e)}
                                            value={user.passwordHash}
                                      />
                                        {errors["passwordHash"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["passwordHash"]}</FormHelperText>}
                                
                                    </div>

                                    <div className="col-md">
                                        <InputLabel shrink id="roleId">Role *</InputLabel>
                                        <Select select
                                            fullWidth 
                                            id="roleId"
                                            name="roleId"
                                            value={user.roleId}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Role--</MenuItem>
                                        {renderDropDown(roles)}
                                        </Select>
                                        {errors["roleId"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["roleId"]}</FormHelperText>}
                                
                                    </div>
                                    <div className="col-md" hidden={!edit}></div>
                        </div>

                       

                                <label htmlFor="roleId">Active</label>
                                <div className="form-group row">
                                   <div className="col-md">
                                    
                                      
                                        <input
                                        className="mr-2"
                                        id="isActive"
                                        switch="none"
                                        type="checkbox"
                                        name="isActive"
                                        onChange={(e) => handleChange(e)}
                                        checked={user.isActive}
                                        />
                                        <label htmlFor="isActive" data-on-label="Yes"
                                        data-off-label="No"></label>
                                     
                                    </div>
                                </div>

                                <label htmlFor="roleId">Locked</label>
                                <div className="form-group row">
                                  <div className="col-md">
                               
                                   
                                    <input
                                        className="mr-2"
                                        id="isLocked"
                                        switch="dark"
                                        type="checkbox"
                                        name="isLocked"
                                        onChange={(e) => handleChange(e)}
                                        checked={user.isLocked}
                                    />
                                    <label htmlFor="isLocked" data-on-label="Yes"
                                        data-off-label="No"></label>
                               
                                    </div>
                                </div>
                                </div>

                            <MessageModal
                            hidden={messageModel.hidden}
                            messageType={messageModel.type}
                            messageDescription={messageModel.disciption}
                            clicked={modalDismissHandler}
                            />
                          

                        <div className="card-footer">
                                <input
                                    type="submit"
                                    className="btn btn-primary"
                                    value={pageProperties.submitButtonName}
                                    onClick={handleSave}
                                />
                                <input
                                    type="reset"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={onCancelClick}
                                 />
                     </div>
                  </form>
                </div>
               </div>
              </div>
        </Fragment>
    );
}